import { useLayoutEffect } from 'react'
import TenantBar from './TenantBar.jsx'
import UserBar from './UserBar.jsx'
import NotificationBar from './NotificationBar.jsx'
import LogoEchoSystem from '../components/ui/LogoEchoSystem.jsx'

const HeaderNavBar = ({companiesList,branchesList,tenantUsername,tenant,companySelected,branchSelected}) => {
    useLayoutEffect(() => {
        const headerElement = document.querySelector('.primary-bg-color.sticky');
        if (!headerElement) return;
        const update = () => {
            document.documentElement.style.setProperty('--header-height', `${headerElement.offsetHeight}px`);
        };
        update();
        requestAnimationFrame(update);
        const observer = new ResizeObserver(update);
        observer.observe(headerElement);
        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div className='primary-bg-color sticky top-0 z-[100] text-white'>
                <NotificationBar />
                <div className="px-3  m-auto  w-full p-1">
                    <div className='flex flex-col md:flex-row w-full py-1 items-center gap-2 md:gap-4'>
                        <div className='flex flex-1 items-center justify-between w-full md:w-auto'>
                        <TenantBar 
                            companiesList = {companiesList}
                            branchesList = {branchesList}
                            companySelected={companySelected} 
                            branchSelected={branchSelected} />
                        </div>
                        <div className="shrink-0 flex items-center justify-center w-full md:w-auto">
                            <LogoEchoSystem tenantUsername={tenantUsername} />
                        </div>
                        <div className="flex flex-1 items-center justify-end w-full md:w-auto">
                            <UserBar
                                tenantUsername = {tenantUsername}
                                tenant = {tenant}
                            />
                        </div>
                    </div> 
                </div>
            </div>
        </>
    )
}

export default  HeaderNavBar 
